import { queryOptions } from "@tanstack/react-query";
import { z } from "zod";
import { axiosInstance } from "./axios";
import { scoutingPlayerSchema, scoutingGoalkeeperSchema, scoutingKpiInfoSchema } from "./scouting";

export interface FollowedPlayerResponse {
    id: number;
    playerId: number;
    userOid: string;
    createdAt: string;
}

export const followPlayer = (playerId: number): Promise<FollowedPlayerResponse> =>
    axiosInstance.post<FollowedPlayerResponse>(`/followed-players/${playerId}`).then((r) => r.data);

export const unfollowPlayer = (playerId: number): Promise<void> =>
    axiosInstance.delete(`/followed-players/${playerId}`).then(() => undefined);

export const followedPlayerIdsQueryOptions = () =>
    queryOptions({
        queryKey: ["followed-player-ids"],
        queryFn: () => axiosInstance.get<number[]>("/followed-players/ids").then((r) => r.data),
        staleTime: 2 * 60 * 1000,
    });

const followedScoutingResponseSchema = z.object({
    playerReferenceData: scoutingKpiInfoSchema.optional(),
    goalkeeperReferenceData: scoutingKpiInfoSchema.optional(),
    players: z.array(scoutingPlayerSchema),
    goalKeepers: z.array(scoutingGoalkeeperSchema),
});

export type FollowedScoutingResponse = z.infer<typeof followedScoutingResponseSchema>;

export const followedScoutingQueryOptions = (tournamentId: number) =>
    queryOptions({
        queryKey: ["followed-scouting", tournamentId],
        queryFn: async () => {
            const response = await axiosInstance.get(`/${tournamentId}/followed-players/scouting`);
            return followedScoutingResponseSchema.parse(response.data);
        },
        staleTime: 5 * 60 * 1000,
    });

